import { PAYMENT_METHOD_HASH_TYPE_STRIPE_PAYMENT_ELEMENT } from '../../constants';

export const stripePaymentElementPaymentMethodHashPayloadFactory = (
  token: string,
  paymentMethodConfiguration: string,
): object => ({
  type: PAYMENT_METHOD_HASH_TYPE_STRIPE_PAYMENT_ELEMENT,
  [PAYMENT_METHOD_HASH_TYPE_STRIPE_PAYMENT_ELEMENT]: {
    token,
    paymentMethodConfiguration,
  },
});
